import { Pipe } from '@angular/core';
import { isObject } from '../utils/utils';
var ToArrayPipe = (function () {
    function ToArrayPipe() {
    }
    ToArrayPipe.prototype.transform = function (input) {
        if (!isObject(input)) {
            return input;
        }
        return Object.keys(input).map(function (value) { return input[value]; });
    };
    return ToArrayPipe;
}());
export { ToArrayPipe };
ToArrayPipe.decorators = [
    { type: Pipe, args: [{ name: 'toArray' },] },
];
/** @nocollapse */
ToArrayPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=to-array.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/object/to-array.pipe.js
// module id = 272
// module chunks = 103